var loaderHidden = false; // Flag to track loader visibility
var minimumLoaderTime = 500; // Minimum time to display the loader in milliseconds
var loaderStartTime; // Time when loader starts

function isLoaderDevModeEnabled() {
    return window.loaderDevMode === true;
}

function handleLoadingAnimation() {
    var totalElements = $('img').length + ($('video').length ? 1 : 0);
    var loadedElements = 0;

    // Record the start time of the loader
    loaderStartTime = new Date().getTime();

    // Function to hide the loader
    function hideLoader() {
        var currentTime = new Date().getTime();
        var elapsedTime = currentTime - loaderStartTime;

        if (!loaderHidden && elapsedTime >= minimumLoaderTime && !isLoaderDevModeEnabled()) {
            $(".loader-wrapper").fadeOut("slow");
            loaderHidden = true;
        } else if (!loaderHidden && !isLoaderDevModeEnabled()) {
            setTimeout(hideLoader, minimumLoaderTime - elapsedTime);
        }
    }

    // Update the animation based on loading progress
    function updateAnimationProgress() {
        var progress = loadedElements / totalElements;
        var clipPathValue = `inset(0 ${100 - (progress * 100)}% 0 0)`;
        $(".loader .shadow-image").css("clip-path", clipPathValue);
        // Preserve the inline translate/scale from customizer settings
        var $shadow = $(".loader .shadow-image");
        var baseTransform = $shadow.attr("data-base-transform") || "";
        var scaleValue = loadedElements < totalElements ? 1.1 : 1;
        $shadow.css("transform", baseTransform + ` scale(${scaleValue})`);
    }

    // Store base transforms from inline styles so JS animations don't overwrite them
    $(".loader .full-image, .loader .shadow-image").each(function() {
        var inlineTransform = this.style.transform || "";
        $(this).attr("data-base-transform", inlineTransform);
    });

    // When all elements are loaded
    function completeLoading() {
        var finishAnim = window.loaderFinishAnimation || 'bounce';
        var $shadow = $(".loader .shadow-image");
        // Remove any loading animation class
        $shadow.removeClass('loaded');
        $shadow[0] && $shadow[0].classList.forEach(function(cls) {
            if (cls.startsWith('finish-')) $shadow.removeClass(cls);
        });
        if (finishAnim !== 'none') {
            $shadow.addClass('finish-' + finishAnim);
        }
        hideLoader();
    }

    // Event listener for image and video load
    $('img').on('load', function() {
        loadedElements++;
        if (loadedElements === totalElements) {
            completeLoading();
        } else {
            updateAnimationProgress();
        }
    }).each(function() {
        if (this.complete) {
            $(this).trigger('load');
        }
    });

    var video = $('video').get(0);
    if (video) {
        video.oncanplaythrough = function() {
            loadedElements++;
            if (loadedElements === totalElements) {
                completeLoading();
            } else {
                updateAnimationProgress();
            }
        };
        if (video.readyState >= 4) {
            $(video).trigger('canplaythrough');
        }
    } else {
        loadedElements++;
        if (loadedElements === totalElements) {
            completeLoading();
        } else {
            updateAnimationProgress();
        }
    }

    // Initial state of the loader
    $(".loader-wrapper").fadeIn("slow");
    updateAnimationProgress();
}

// Reset and show the loader when starting navigation
function resetAndShowLoader() {
    loaderHidden = false;
    $(".loader-wrapper").show();
    $(".loader .shadow-image").removeClass('loaded');
    if (isLoaderDevModeEnabled()) {
        return;
    }
    handleLoadingAnimation();
}

// Call the loading animation function when the page starts loading
$(document).ready(function() {
    if (isLoaderDevModeEnabled()) {
        loaderHidden = false;
        $(".loader-wrapper").show();
        $(".loader .shadow-image").css("clip-path", "none");
        return;
    }
    handleLoadingAnimation();
});

// Hide loader on initial full page load
$(window).on("load", function() {
    if (isLoaderDevModeEnabled()) {
        loaderHidden = false;
        $(".loader-wrapper").show();
        $(".loader .shadow-image").css("clip-path", "none");
        return;
    }
    loaderHidden = true; // Ensure loader is marked as hidden
    $(".loader-wrapper").fadeOut("slow");
});

// Reinitialize on Shopify's AJAX page load
$(document).on('page:load page:change', function() {
    if (isLoaderDevModeEnabled()) {
        loaderHidden = false;
        $(".loader-wrapper").show();
        return;
    }
    loaderHidden = false; // Reset loader visibility for AJAX pages
    resetAndShowLoader();
});
